import { Component, Input, OnInit } from '@angular/core';
import {
  addToCartCalculations,
  calculationTypes,
  noModelCalculationTypes,
  rainSystemCalculation,
} from 'src/app/calculation/calculation.constants';

@Component({
  selector: 'calculation-types',
  templateUrl: './calculation-types.component.html',
  styleUrls: ['./calculation-types.component.scss'],
})
export class CalculationTypesComponent implements OnInit {
  calculationTypes = [...calculationTypes, ...noModelCalculationTypes];
  @Input()
  displayAutomatedOnly = false;

  ngOnInit() {
    if (this.displayAutomatedOnly) {
      this.calculationTypes = [...addToCartCalculations, rainSystemCalculation];
    }
  }
}
